import TripItem from "./TripItem"

export default  TripItem;



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripItem/index.js